<template>
  <div id="profile-container">
    <!-- Username and password change dialog -->
    <v-dialog v-model="editModal" max-width="790" content-class="editModal">
      <div v-if="editUsernameActive" class="edit">
        <img
          @click="
            editModal = false;
            clearUsername();
          "
          class="close-icon"
          src="../../assets/icons/close.png"
          alt="Close"
        />
        <h2>Izmjena korisničkog imena</h2>
        <v-container>
          <v-layout row wrap>
            <v-flex xs7>
              <v-text-field
                label="Korisničko ime"
                v-model="username"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="text-right">
              <v-btn @click="changeUsername" class="main-btn">Uredi</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div v-if="editPasswordActive" class="edit">
        <img
          @click="
            editModal = false;
            clearPasswords();
          "
          class="close-icon"
          src="../../assets/icons/close.png"
          alt="Close"
        />
        <h2>Izmjena lozinke</h2>
        <v-container>
          <v-layout row wrap>
            <v-flex xs7>
              <v-text-field
                type="password"
                label="Stara lozinka"
                v-model="oldPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs7>
              <v-text-field
                type="password"
                label="Nova lozinka"
                v-model="newPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs7>
              <v-text-field
                type="password"
                label="Nova lozinka"
                v-model="newPasswordRepeat"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="text-right">
              <v-btn @click="changePassword" class="main-btn">Uredi</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-dialog>
    <!-- FILTERS DIALOG -->
    <v-dialog
      v-model="isFilterDialog"
      max-width="790"
      content-class="editModal"
    >
      <reports-filter
        :showCloseIcon="true"
        :isRelative="true"
        @onCloseClicked="isFilterDialog = false"
        @onFilterChanged="filterChanged"
      >
      </reports-filter>
    </v-dialog>
    <!-- STUDENT FILTER DIALOG -->
    <v-dialog
      v-model="isStudentFilterDialog"
      max-width="790"
      content-class="editModal"
    >
      <users-filter
        @onPolaznikSelected="polaznikSelected"
        :profesorId="profileId"
        :showActions="true"
        @onFilterClicked="isStudentFilterDialog = false"
        @onResetClicked="
          isStudentFilterDialog = false;
          polaznikSelected(null);
        "
      ></users-filter>
    </v-dialog>
    <!-- STUDENT FILTER DIALOG -->
    <v-dialog
      v-model="isProfesorStudentManagmentDialog"
      max-width="790"
      content-class="editModal"
    >
      <ProfPolaznikManagment
        :showUsersFilter="showUsersFilter"
        :profesorId="profileId"
        @polaznikDelete="onPolaznikDelete"
        @polaznikAdded="onPolaznikAdded"
      />
    </v-dialog>
    <div v-if="isProfesorProfile" class="profile-left-root">
      <users-filter
        v-if="showUsersFilter"
        @onPolaznikSelected="polaznikSelected"
        :profesorId="profileId"
      ></users-filter>
    </div>
    <div
      v-if="!isNoReportsProfile"
      class="profile-center-root"
      :class="{
        'no-left-area': !isProfesorProfile,
        'is-in-focus': !isUserBadges,
      }"
    >
      <reports-table
        :tableData="tableData"
        :numberOfPages="numberOfPages"
        :reportEdit="reportEdit"
        :reportPreview="reportPreview"
        :reportDisabled="reportDisabled"
        :selectedPage="selectedPage"
        @refreshTableData="onSelectedPageChanged"
      />
    </div>
    <div
      class="profile-right-root"
      :class="{ 'no-reports': isNoReportsProfile }"
    >
      <div style="z-index: 10">
        <div id="profile-edit">
          <!-- <EDIT> -->
          <v-menu
            open-on-click
            bottom
            offset-y
            style="float: right; z-index: 100"
          >
            <img
              v-if="profileEditAndFilters.items.length > 0"
              slot="activator"
              class="action-icon-sm"
              src="../../assets/icons/three-dot.png"
              alt="Filter user"
            />
            <v-list>
              <v-list-tile
                v-for="(item, index) in profileEditAndFilters.items"
                :key="index"
                @click="openEditDialog(item.value)"
              >
                <v-list-tile-title>
                  <span>{{ item.text }}</span>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <!-- </EDIT> -->
        </div>
        <div class="user-info-container">
          <div class="user-info-root">
            <div
              :style="{ backgroundImage: 'url(' + user.PhotoUrl + ')' }"
              class="user-profile"
            >
              <div class="change-profile" @click="selectProfile">
                Promjeni sliku
              </div>
              <input
                type="file"
                ref="file"
                id="change-image"
                class="d-none"
                @change="changeProfile"
              />
            </div>
            <div class="user-info">
              <p class="name">{{ user.Name }}</p>
              <p class="username">{{ user.Username }}</p>
            </div>
            <div class="show-user-badges-root" @click="toggleUserBadges">
              <img
                src="../../assets/icons/arrow-down.png"
                :class="{ 'arrow-up': isUserBadges }"
              />
            </div>
          </div>

          <div v-if="isUserBadges" class="user-badges">
            <h3 class="highlighted-header">Korisničke uloge</h3>
            <br />
            <p
              v-for="role in user.Roles"
              :key="role.Name"
              class="role-instrument"
            >
              {{ role.Name }}
            </p>
            <br />
            <div v-if="user.Instruments.length">
              <h3 class="highlighted-header">Instrumenti</h3>
              <br />
              <p
                v-for="instrument in user.Instruments"
                :key="instrument.Name"
                class="role-instrument"
              >
                {{ instrument.Name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isUserBadges && !isNoReportsProfile"
        class="filter-area-overlay"
        @click="toggleUserBadges"
      ></div>
      <reports-filter
        v-if="!isNoReportsProfile && !isSmallScreen"
        @onFilterChanged="filterChanged"
      ></reports-filter>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
import ReportsFilter from "../Reusable/ReportsFilter";
import UsersFilter from "../Reusable/UsersFilter";
import ReportsTable from "../Reusable/ReportsTable";
import ProfPolaznikManagment from "../Reusable/ProfesorPolaznikManagment.vue";
import { formatAppointments } from '../../helpers';

export default {
  components: {
    ReportsFilter,
    UsersFilter,
    ReportsTable,
    ProfPolaznikManagment,
  },
  computed: {
    isSmallScreen() {
      return window.innerWidth < 1200;
    },
  },
  data() {
    return {
      user: {},
      profileEditAndFilters: {
        isProfileEdit: false,
        items: [],
      },
      isFilterDialog: false,
      isStudentFilterDialog: false,
      isProfesorStudentManagmentDialog: false,
      //For profile edit
      profilePicture: null,
      editUsernameActive: false,
      username: null,
      editPasswordActive: false,
      oldPassword: null,
      newPassword: null,
      newPasswordRepeat: null,
      userImageFile: null,
      editModal: false,

      // Profile reports
      profileId: null,
      visitiorId: null,
      tableData: [],
      numberOfPages: 1,
      selectedPage: 1,
      polaznikId: null,
      filterData: null,
      isProfesorProfile: false,
      isNoReportsProfile: false,
      reportEdit: false,
      reportPreview: false,
      reportDisabled: false,
      isUserBadges: false,

      // Helpers
      showUsersFilter: true,
    };
  },
  methods: {
    getUserInfo() {
      let self = this;
      let profileId = self.profileId;
      return new Promise(function(resolve, reject) {
        self.$store.state.services.userService
          .userProfile(profileId)
          .then((response) => {
            self.user = response.data;
            self.username = self.user.Username;
            resolve(response.data);
          });
      });
    },
    changeUsername() {
      this.$store.state.services.userService
        .changeUsername(localStorage.getItem("user"), this.username)
        .then((response) => {
          this.$store.dispatch("setResponseMessage", response.data);
          if (response.data.IsError == false) {
            this.getUserInfo();
            this.clearUsername();
            this.editUsernameActive = false;
          }
        });
    },
    changePassword() {
      if (this.newPassword != this.newPasswordRepeat) {
        alert("Polja novog passworda se razlikuju");
        return;
      }
      this.$store.state.services.userService
        .changePassword(
          localStorage.getItem("user"),
          this.oldPassword,
          this.newPassword
        )
        .then((response) => {
          this.$store.dispatch("setResponseMessage", response.data);
          if (response.data.IsError == false) {
            this.logout();
          }
        });
    },
    selectProfile() {
      var selectImageInput = document.getElementById("change-image");
      selectImageInput.click();
    },
    changeProfile() {
      this.user.UserId = localStorage.getItem("user");
      this.$store.state.services.userService
        .changeProfile(this.user, this.$refs.file.files[0])
        .then((response) => {
          this.getUserInfo().then((res) => {
            localStorage.setItem("user-profile", this.user.PhotoUrl);
            bus.$emit("profileImageChanged");
            this.$store.dispatch("setResponseMessage", response.data);
          });
        });
    },
    openEditDialog(value) {
      this.editUsernameActive = false;
      this.editPasswordActive = false;
      this.isFilterDialog = false;
      this.isStudentFilterDialog = false;

      switch (value) {
        case "korIme":
          this.editUsernameActive = true;
          this.editModal = true;
          break;
        case "password":
          this.editPasswordActive = true;
          this.editModal = true;
          break;
        case "filter":
          this.isFilterDialog = true;
          break;
        case "filterByPolaznik":
          this.isStudentFilterDialog = true;
          break;
        case "polaznikManagment":
          this.isProfesorStudentManagmentDialog = true;
          break;
      }
    },
    clearUsername() {
      this.username = this.user.Username;
    },
    clearPasswords() {
      this.oldPassword = null;
      this.newPassword = null;
      this.newPasswordRepeat = null;
    },
    logout() {
      localStorage.setItem("user-roles", "");
      localStorage.setItem("user-token", "");
      localStorage.removeItem("unpaid-subscription");
      this.$store.state.services.resetAxiosHeader();
      this.$router.push("/");
    },
    filterChanged(filterData) {
      this.filterData = filterData;
      if (!filterData.initialEmit) this.getReportData();
      this.isFilterDialog = false;
    },
    polaznikSelected(polaznikId) {
      this.polaznikId = polaznikId;
      this.selectedPage = 1;
      this.getReportData();
    },
    onSelectedPageChanged(selectedPage) {
      this.selectedPage = selectedPage;
      this.getReportData();
    },
    getReportData() {
      this.$store.state.services.appointmentService
        .getReportsForProfile(this.selectedPage, {
          ...this.filterData,
          ...{ ProfileId: this.profileId, QueryUserId: this.polaznikId },
        })
        .then((result) => {
          this.tableData = formatAppointments(result.data.Appointments);
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch((err) => {});
    },
    onPolaznikDelete(polaznik) {
      if (
        confirm(
          `Da li ste sigurni da zelite izbrisati polaznika ${
            polaznik.Name
          } iz svojih ucenika?`
        )
      ) {
        this.$store.state.services.userService
          .removeStudentFromProfessor(this.profileId, polaznik.UserId)
          .then((response) => {
            // hack to refresh users after the new ones are added
            // to refactor
            this.showUsersFilter = false;
            setTimeout(() => {
              this.showUsersFilter = true;
            }, 100);
          })
          .catch((err) => {})
          .finally(() => {});
      } else {
        // Do nothing!
      }
    },
    onPolaznikAdded(polaznik) {
      if (
        confirm(
          `Da li ste sigurni da zelite dodati polaznika ${
            polaznik.Name
          } u svoje ucenike?`
        )
      ) {
        this.$store.state.services.userService
          .addStudentToProfessor(this.profileId, polaznik.UserId)
          .then((response) => {
            // hack to refresh users after the new ones are added
            // to refactor
            this.showUsersFilter = false;
            setTimeout(() => {
              this.showUsersFilter = true;
            }, 100);
          })
          .catch((err) => {})
          .finally(() => {});
      } else {
        // Do nothing!
      }
    },
    onPageCreated() {
      if (this.$route.params.targetId) {
        this.profileId = this.$route.params.targetId;
        let targetProfileRoleList =
          this.$route.params.targetProfileRoleList ||
          localStorage.getItem("targetProfileRoleList").split(",");

        if (
          this.$store.state.services.checkRole("Administrator") ||
          this.$store.state.services.checkRole("Supervizor")
        ) {
          this.reportPreview = true;
        } else {
          this.reportDisabled = true;
        }
        // Profesor profile visited
        if (
          targetProfileRoleList.filter(
            (x) => x.Name === "Profesor" || x === "Profesor"
          ).length
        ) {
          this.isProfesorProfile = true;
        } else if (
          targetProfileRoleList.filter(
            (x) => x.Name === "Polaznik" || x === "Polaznik"
          ).length
        ) {
          // Polaznik profile is visited
        } else {
          // Others profile is visited
          this.isNoReportsProfile = true;
        }
      } else {
        this.profileId = localStorage.getItem("user");
        this.profileEditAndFilters.isProfileEdit = true;

        // Profesor visits his profile
        if (this.$store.state.services.checkRole("Profesor")) {
          this.isProfesorProfile = true;
          this.reportEdit = true;
        } else if (this.$store.state.services.checkRole("Polaznik")) {
          // Polaznik visits his profile
          this.reportEdit = false;
          this.reportDisabled = true;

        } else {
          // Others visit their profile
          this.isNoReportsProfile = true;
        }
      }
      // Setting the modal actions content
      this.profileEditAndFilters.items = [];
      if (this.profileEditAndFilters.isProfileEdit) {
        this.profileEditAndFilters.items.push({
          text: "Uredi korisnicko ime",
          value: "korIme",
        });
        this.profileEditAndFilters.items.push({
          text: "Uredi lozinku",
          value: "password",
        });
      }
      let smallScreen = window.innerWidth < 1100;
      if (smallScreen && !this.isNoReportsProfile) {
        this.profileEditAndFilters.items.push({
          text: "Filteri",
          value: "filter",
        });
      }
      if (this.isProfesorProfile && smallScreen) {
        this.profileEditAndFilters.items.push({
          text: "Filtriraj po polazniku",
          value: "filterByPolaznik",
        });
      }
      if (this.isProfesorProfile && this.reportEdit) {
        this.profileEditAndFilters.items.push({
          text: "Upravljanje polaznicima",
          value: "polaznikManagment",
        });
      }
      this.getUserInfo();
      if (!this.isNoReportsProfile) {
        this.getReportData();
      }
    },
    toggleUserBadges() {
      this.isUserBadges = !this.isUserBadges;
    },
  },
  created() {
    this.onPageCreated();
  },
  watch: {
    $route: {
      handler: function() {
        this.onPageCreated();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
#profile-container {
}

.profile-left-root {
  position: fixed;
  top: 80px;
  width: calc(30% - 30px);
  left: 20px;
  bottom: 20px;
  background-color: white;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}

.profile-center-root {
  position: fixed;
  top: 80px;
  left: calc(30% + 10px);
  bottom: 20px;
  right: calc(25% + 40px);
  background-color: white;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}
.profile-center-root.is-in-focus {
  z-index: 11;
}
.profile-center-root.no-left-area {
  left: 10px;
}
.profile-right-root {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  right: 20px;
  top: 80px;
  bottom: 20px;
  z-index: 10;
}
.profile-right-root.no-reports {
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
}

#profile-edit {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}
.user-info-container {
  z-index: 1;
  background-color: #fff;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}

.user-info-root {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px;
}
.show-user-badges-root {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.show-user-badges-root img {
  width: 100%;
}
.show-user-badges-root img.arrow-up {
  transform: rotate(180deg);
}
.user-badges {
  padding: 0 20px 20px 20px;
}
.user-profile {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  margin-right: 20px;
}
.user-profile:hover .change-profile {
  display: flex;
}
.user-profile .change-profile {
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  color: white;
  cursor: pointer;
}
.name {
  font-size: 18px;
  margin: 0;
  font-weight: 400;
}
.username {
  font-size: 12px;
  color: #657786;
  margin-bottom: 0;
}
h2 {
  margin-top: 20px;
}
h3 {
  display: inline-block;
}
.role-instrument {
  font-size: 12px;
  display: inline-block;
  margin: 10px 5px;
  padding: 5px 10px;
  background-color: #039be5;
  border-radius: 20px;
  color: #fff;
}
.filter-area-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  cursor: pointer;
}
.edit {
  position: relative;
}
@media (max-width: 768px) {
  #profile-container {
    width: 100%;
  }
  .close-icon {
    top: 0;
    right: 0;
  }
}

/* FOR SMALLER SCREENS LOGIC */
@media (max-width: 1100px) {
  .profile-left-root {
    display: none;
  }
  .profile-center-root {
    left: 10px;
    right: 10px;
    top: 180px;
  }
  .profile-right-root {
    left: 10px;
    right: 10px;
    width: auto;
  }
  .profile-right-root.no-reports {
    left: 10px;
    transform: translateX(0);
    width: calc(100% - 20px);
  }
}
</style>

<style>
.editModal {
  background-color: white;
  padding: 20px;
}

.highlighted-header {
  position: relative;
  display: inline-block;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 5px;
}
.highlighted-header::after {
  content: "";
  position: absolute;
  width: 45%;
  height: 2px;
  border-radius: 10px;
  background-color: #8fb7ca;
  bottom: -3px;
  left: 0;
}
</style>
